var l = /* @__PURE__ */ ((e) => (e.Floating = "floating", e.Fixed = "fixed", e))(l || {}), r = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Small = "small", e))(r || {});
export {
  r as SizesEnum,
  l as VariantsEnum
};
